"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconCircleBackground = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const IconCircleBackground = ({ children, variant }) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: `bg-${variant} p-2 rounded-pill position-relative`, children: (0, jsx_runtime_1.jsx)("div", { className: "position-absolute translate-middle d-flex align-items-center justify-content-end", style: { left: '49%', top: '49%' }, children: children }) }));
};
exports.IconCircleBackground = IconCircleBackground;
